






































import { Component, Vue, Prop } from 'vue-property-decorator'
import api from '@/api'
import { TextInput, Button } from '@alpha/ink'

@Component({
  components: {
    TextInput,
    Button
  }
})
export default class ResetPassword extends Vue {
  @Prop({ default: '' }) email!: string
  @Prop({ default: '' }) token!: string
  @Prop({ default: '' }) uid!: string

  validToken: boolean = false
  checkingToken: boolean = true
  password: string = ''
  confirmPassword: string = ''
  processing: boolean = false
  message: string = ''
  messageType: 'error' | 'success' | '' = ''
  userId?: string

  goToForgot () {
    this.$emit('toggleMode', { mode: 'forgot' })
  }

  mounted () {
    this.checkResetPasswordToken()
  }

  handleFormKeypress (e: KeyboardEvent) {
    e.stopPropagation()
    if (e.key === 'Enter') {
      e.preventDefault()
      this.submit()
    }
  }

  async checkResetPasswordToken () {
    const token = this.$route.query.token as string
    if (!token) {
      this.validToken = false
      this.checkingToken = false
      return
    }

    const status = await api.checkResetPasswordToken(token)
      .catch(() => {
        console.log('not valid')
      })

    this.validToken = !!status && !!status.userId
    this.userId = (status && status.userId) || undefined
    this.checkingToken = false
  }

  async submit () {
    const token = this.$route.query.token as string
    if (!this.userId) return
    const passwordRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
    this.message = ''
    if (this.password === '') {
      this.message = 'Please enter a new password'
      this.messageType = 'error'
      return
    } else if (!passwordRegex.test(this.password)) {
      this.message = 'Please use at least 8 characters, must contain at least 1 uppercase letter, 1 lowercase letter, and 1 Number'
      this.messageType = 'error'
      return
    } else if (this.confirmPassword !== this.password) {
      this.message = "Your passwords don't match"
      this.messageType = 'error'
      return
    }
    this.processing = true
    const payload = {
      userId: this.userId,
      token,
      password: this.password
    }
    const status = await api.resetPassword(payload)
    if (status && status.status) {
      this.$emit('toggleMode', { mode: 'login', message: 'Your password was reset' })
    } else {
      this.message = 'An error occured updating your password. Please contact your csm.'
    }

    this.processing = false
  }
}
